import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {ToolFormDetails, ToolFormModel} from "@app/tool/tool-form-modal/tool-create.model";

@Component({
  selector: 'app-tool-special-identifiers-form',
  templateUrl: './tool-special-identifiers-form.component.html',
  styleUrls: ['./tool-special-identifiers-form.component.scss']
})
export class ToolSpecialIdentifiersFormComponent implements  OnInit, OnChanges {
    @Input() toolFormModel: ToolFormModel;

    @Output() identifiersChanged = new EventEmitter<ToolFormDetails>();

    specialIdentifiersForm: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.initForm();
        this.subscribeToChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolFormModel'] && this.toolFormModel && this.specialIdentifiersForm) {
            this.loadFormValues(this.toolFormModel);
        }
    }

    resetForm() {
        this.specialIdentifiersForm.reset();
    }

    getFormValue(): ToolFormDetails {
        return this.specialIdentifiersForm.value;
    }

    onToolStationedAtERSAChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['excludedFromReturn'].setValue(false);
        }
    }

    onToolExcludedFromReturnChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['isToolStationedAtERSA'].setValue(false);
        }
    }

    onToolDirectContactWithPCBChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['manualHandling'].setValue(false);
        }
    }

    onToolManualHandlingChanged(value) {
        if (value) {
            this.specialIdentifiersForm.controls['directContactWithPCB'].setValue(false);
        }
    }

    private loadFormValues(toolFormModel: ToolFormModel) {
        this.specialIdentifiersForm.setValue({
            isToolLifeMonitoredInSap: toolFormModel.isToolLifeMonitoredInSap,
            isToolLifeMonitoredInMes: toolFormModel.isToolLifeMonitoredInMes,
            isToolLifeMonitoredInPlc: toolFormModel.isToolLifeMonitoredInPlc,
            hasMaintenaceAtLine: toolFormModel.hasMaintenaceAtLine,
            excludedFromMaintenance: toolFormModel.excludedFromMaintenance,
            isToolStationedAtERSA: toolFormModel.isToolStationedAtERSA,
            excludedFromReturn: toolFormModel.excludedFromReturn,
            directContactWithPCB: toolFormModel.directContactWithPCB,
            manualHandling: toolFormModel.manualHandling
        });
    }

    private initForm() {
        this.specialIdentifiersForm = new UntypedFormGroup({
        isToolLifeMonitoredInSap: new UntypedFormControl(this.toolFormModel?.isToolLifeMonitoredInSap || false),
        isToolLifeMonitoredInMes: new UntypedFormControl(this.toolFormModel?.isToolLifeMonitoredInMes || false),
        isToolLifeMonitoredInPlc: new UntypedFormControl(this.toolFormModel?.isToolLifeMonitoredInPlc || false),
        hasMaintenaceAtLine: new UntypedFormControl(this.toolFormModel?.hasMaintenaceAtLine || false),
        excludedFromMaintenance: new UntypedFormControl(this.toolFormModel?.excludedFromMaintenance || false),
        isToolStationedAtERSA: new UntypedFormControl(this.toolFormModel?.isToolStationedAtERSA || false),
        excludedFromReturn: new UntypedFormControl(this.toolFormModel?.excludedFromReturn || false),
        directContactWithPCB: new UntypedFormControl(this.toolFormModel?.directContactWithPCB || false),
        manualHandling: new UntypedFormControl(this.toolFormModel?.manualHandling || false)
        });
    }

      private subscribeToChanges() {
        this.specialIdentifiersForm.valueChanges.subscribe((val: ToolFormDetails) => {
        this.identifiersChanged.emit(val);
        });
    }

}
